import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {RouterModule} from "@angular/router";
import {TranslateDirective, TranslatePipe} from "@ngx-translate/core";
import {map, Observable} from "rxjs";
import {BlogService} from "../../../services/blog.service";
import {MainPagesContainerComponent} from "../main-pages-container/main-pages-container.component";
import {LANDING_CLUSTERS} from "../landing/landing-clusters";
import {environment} from "../../../../environments/environment";
import {ChatVersions} from "../../../../../shared/chat.versions";

interface Article {
    title: string;
    id: string;
}

interface ArticleGroup {
    title: string;
    /** Путь лендинга-хаба темы; пустой у группы с остальными статьями */
    slug: string;
    articles: Article[];
}

@Component({
    selector: 'app-blog-list',
    templateUrl: './blog-list.component.html',
    styleUrls: ['../main.pages.scss', './blog-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        RouterModule,
        TranslatePipe, TranslateDirective,
        MainPagesContainerComponent,
    ]
})
export class BlogListComponent implements OnInit {
    protected groups$: Observable<ArticleGroup[]>;

    constructor(private blogService: BlogService) {
    }

    ngOnInit() {
        this.groups$ = this.blogService.getArticlesList().pipe(
            map(articles => this.groupByCluster(articles))
        );
    }

    // Статьи раскладываются по темам своих лендингов: заголовок группы ведёт на лендинг,
    // так список перестаёт быть плоским и связывает хаб с его материалами.
    // В VT-сборке лендингов нет, поэтому там остаётся один общий список.
    private groupByCluster(articles: Article[]): ArticleGroup[] {
        if (environment.chatVersion !== ChatVersions.SX) {
            return [{title: '', slug: '', articles}]
        }

        const byId = new Map(articles.map(article => [article.id, article]))
        const groups: ArticleGroup[] = []

        for (const cluster of LANDING_CLUSTERS) {
            const clusterArticles = cluster.articleIds
                .map(id => byId.get(id))
                .filter((article): article is Article => !!article)

            clusterArticles.forEach(article => byId.delete(article.id))

            if (clusterArticles.length) {
                groups.push({title: cluster.title, slug: cluster.slug, articles: clusterArticles})
            }
        }

        // Статьи, ещё не отнесённые ни к одной теме, не должны пропадать из списка
        const rest = [...byId.values()]
        if (rest.length) {
            groups.push({title: 'More articles', slug: '', articles: rest})
        }

        return groups
    }
}
